import { z } from "zod";
//
// Difference
//
/**
 * @deprecated
 */
export const DTODocumentationPageAnalyticsDifference = z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date().optional(),
    currentVisitCount: z.number(),
    currentSessionCount: z.number(),
    priorVisitCount: z.number(),
    priorSessionCount: z.number(),
});
/**
 * @deprecated
 */
export const DTODocumentationPageIntervalDifferenceResponse = z.object({
    differences: z.array(DTODocumentationPageAnalyticsDifference),
});
